import { useState } from "react";

// UX-POLISH-01 #2: pairs with <SubmitButton success=.../> — on a mutation's onSuccess, call
// `pulse(() => { ...toast/invalidate/close... })` instead of running that logic immediately.
// Holds the checkmark "wow" state on screen for `duration`ms (matching UX_MOTION.md's
// save/success spec) before running the callback, so the user actually sees the confirmation
// instead of the dialog vanishing the instant the request resolves.
export function useSuccessPulse(duration = 600) {
  const [success, setSuccess] = useState(false);
  const pulse = (onDone) => {
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
      onDone && onDone();
    }, duration);
  };
  return [success, pulse];
}
